export default __webpack_public_path__ + "static/media/chai.d20c909b.mp4";